package com.eladfinish.bible.contest.ui.common

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.platform.LocalUriHandler
import androidx.compose.ui.platform.UriHandler

@Composable
fun rememberSafeUriHandler(
    onFailure: (Throwable, String) -> Unit,
): UriHandler {
    val real = LocalUriHandler.current

    return remember(real, onFailure) {
        object : UriHandler {
            override fun openUri(
                uri: String,
            ) {
                runCatching {
                    real.openUri(uri)
                }.onFailure { e ->
                    onFailure(e, uri)
                }
            }
        }
    }
}
